import React, { useCallback, useContext, useMemo, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Context as BNCClientContext } from 'containers/context/BNCClientProvider'
import { Modal, Button } from '@binance-chain/honeycomb'
import { DexThemeProvider } from 'components/common/DexThemeProvider'
import { useI18n } from 'i18n/util'
import { useSelector, useDispatch } from 'react-redux'
import { useConnectStaking } from 'hooks/connectStaking'
import { actionSetStatus } from 'redux/staking/reducer'
import { View } from './view'

// Hacked, TO DO need to remove
const HeaderContainer = styled.div`
  svg {
    display: none;
  }
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    font-size: 14px;
    line-height: 20px;
    color: #1e2026;
    margin-bottom: 12px;
  }
`
const ButtonGroup = styled.div`
  display: flex;
  margin-top: 30px;
`

const ButtonCancel = styled.div`
  flex: 1;
  margin-right: 20px;
`

const ButtonConfirm = styled.div`
  flex: 1;
`

export const StakingModal = ({ isOpen }) => {
  const { formatI18nText } = useI18n()
  const dispatch = useDispatch()
  const bncClient = useContext(BNCClientContext)
  const childWindow = useConnectStaking()
  const {
    status,
    delegatorAddress,
    validatorAddress,
    amount,
    validatorSrcAddress,
    validatorDstAddress,
  } = useSelector(state => state.staking)
  const [errMsg, setErrMsg] = useState('')

  const { privateKey } = useSelector(state => state.account)

  if (privateKey) {
    privateKey !== 'HARDWARE' &&
      (async () => {
        await bncClient.setPrivateKey(privateKey)
      })()
  }

  const handleConfim = useCallback(async () => {
    let result
    try {
      switch (status) {
        case 'delegate':
          result = await bncClient.stake.bscDelegate({
            delegateAddress: delegatorAddress,
            validatorAddress,
            amount,
          })
          break
        case 'undelegate':
          result = await bncClient.stake.bscUndelegate({
            delegateAddress: delegatorAddress,
            validatorAddress,
            amount,
          })
          break
        case 'redelegate':
          result = await bncClient.stake.bscReDelegate({
            delegateAddress: delegatorAddress,
            validatorSrcAddress,
            validatorDstAddress,
            amount,
          })
          break
        default:
          break
      }

      if (result.status === 200) {
        childWindow.sendMessageToParent({ type: 'operation_success' })
        dispatch(actionSetStatus(`${status}_success`))
      }
    } catch (err) {
      console.log(err)
      childWindow.sendMessageToParent({ type: 'operation_failed', message: err.message })
      dispatch(actionSetStatus(`${status}_failed`))
      setErrMsg(err.message)
    }
  }, [
    amount,
    bncClient.stake,
    delegatorAddress,
    status,
    validatorAddress,
    validatorDstAddress,
    validatorSrcAddress,
    childWindow,
    dispatch,
  ])

  const renderContent = useMemo(() => {
    switch (status) {
      case 'unlock_success':
      case '':
      case undefined:
        return <p>{formatI18nText('staking.goback')}</p>
      case 'delegate_success':
      case 'undelegate_success':
      case 'redelegate_success':
        return <p>{status.replace('_', ' ')}</p>
      case 'delegate_failed':
      case 'undelegate_failed':
      case 'redelegate_failed':
        return <p>{errMsg}</p>
      case 'cancel':
        return <p>User cancelled</p>
      case 'delegate':
      case 'undelegate':
      case 'redelegate':
        return <View type={status} />
      default:
        return <p>{formatI18nText('staking.goback')}</p>
    }
  }, [formatI18nText, status, errMsg])

  const showButtonGroup = useMemo(() => {
    return status === 'delegate' || status === 'undelegate' || status === 'redelegate'
  }, [status])

  const handleCancel = useCallback(() => {
    childWindow.sendMessageToParent({ type: 'operation_cancel' })
    dispatch(actionSetStatus(`cancel`))
  }, [childWindow, dispatch])

  return (
    <DexThemeProvider theme="light">
      <Modal open={isOpen}>
        <HeaderContainer>
          <Modal.Header title={`${formatI18nText('staking.title')} - ${status}`} />
        </HeaderContainer>
        <Modal.Content>
          <Content>{renderContent}</Content>
          {showButtonGroup && (
            <ButtonGroup>
              <ButtonCancel>
                <Button variant="transparent" shape="fill" onClick={handleCancel}>
                  {formatI18nText('staking.cancel')}
                </Button>
              </ButtonCancel>
              <ButtonConfirm>
                <Button variant="primary" shape="fill" onClick={handleConfim}>
                  {formatI18nText('staking.confirm')}
                </Button>
              </ButtonConfirm>
            </ButtonGroup>
          )}
        </Modal.Content>
      </Modal>
    </DexThemeProvider>
  )
}

StakingModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

StakingModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
}

export default StakingModal
